// Service for fetching dynamic market and IPO data
export const marketService = {
  async getMarketIndices() {
    // Simulate API call with dynamic data
    await new Promise(resolve => setTimeout(resolve, 500));
    
    return [
      { 
        symbol: 'NIFTY', 
        price: (21000 + Math.random() * 1000).toFixed(2), 
        change: (Math.random() * 200 - 100).toFixed(2),
        changePercent: ((Math.random() * 2 - 1).toFixed(2)) + '%',
        positive: Math.random() > 0.5 
      },
      { 
        symbol: 'SENSEX', 
        price: (70000 + Math.random() * 2000).toFixed(2), 
        change: (Math.random() * 400 - 200).toFixed(2),
        changePercent: ((Math.random() * 1.5 - 0.75).toFixed(2)) + '%',
        positive: Math.random() > 0.5 
      },
      { 
        symbol: 'BANKNIFTY', 
        price: (45000 + Math.random() * 2000).toFixed(2), 
        change: (Math.random() * 300 - 150).toFixed(2),
        changePercent: ((Math.random() * 1.2 - 0.6).toFixed(2)) + '%',
        positive: Math.random() > 0.5 
      }
    ];
  },

  async getHomeStats() {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    return {
      activeIPOs: Math.floor(Math.random() * 10) + 10,
      totalIssueSize: `₹${(Math.random() * 2000 + 1000).toFixed(0)} Cr`,
      avgListingGains: `${(Math.random() * 15 + 5).toFixed(1)}%`
    };
  },

  async getRecentIPOPerformance() {
    await new Promise(resolve => setTimeout(resolve, 400));
    
    const ipos = await import('../services/ipoService').then(m => m.ipoService.getAllIPOs());
    return ipos.slice(0, 3).map(ipo => ({
      name: ipo.companyName,
      currentPrice: `₹${(300 + Math.random() * 100).toFixed(0)}`,
      listingPrice: ipo.priceRange.split('-')[0],
      change: `${(Math.random() * 20 - 10).toFixed(1)}%`,
      positive: Math.random() > 0.4
    }));
  }
};